import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import ProvidersTable from './components/ProvidersTable';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';
import Loader from 'loaders/Loader';
import { logoutUser } from 'utils';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'utils';

const Providers = () => {
  const navigate = useNavigate();
  const userData = getUserData();
  const clinic_id = userData?.clinic_id ?? null;
  const [providersData, setProvidersData] = useState([]);
  const [loading, setLoading] = useState(true);

  // const fetchProviders = async () => {
  //   try {
  //     const response = await createAPIEndPoint(`clinic_providers/get_all/${clinic_id}`).fetchAll();
  //     setProvidersData(response.data.providers || []);
  //   } catch (err) {
  //     toast.error(err?.response?.data?.error || 'Error fetching providers');
  //     if (err?.response?.data?.error?.includes('Bearer token')) {
  //       logoutUser(navigate);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchProviders = async () => {
    setLoading(true);

    try {
      const response = await createAPIEndPoint(
        `clinic_providers/get_all/${clinic_id}`,
      ).fetchAll();

      const providers = response.data.providers || [];

      // Latest first by created_at
      const sortedProviders = providers.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at),
      );

      setProvidersData(sortedProviders);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Error fetching providers');

      if (err?.response?.data?.error?.includes('Bearer token')) {
        logoutUser(navigate);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProviders();
  }, []);
  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {loading && <Loader />}
      <ProvidersTable
        tableData={providersData}
        loading={loading}
        fetchAgain={fetchProviders}
      />
    </Box>
  );
};

export default Providers;
